import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import swal from 'sweetalert2';
import { ErrorHandlerService } from '../../services/shared/error-handler.service';
import { UserServiceService } from '../../services/user-service/user-service.service';

@Component({
  selector: 'app-add-nationality',
  templateUrl: './add-nationality.component.html',
  styleUrls: ['./add-nationality.component.css']
})
export class AddNationalityComponent implements OnInit {
  title: string = "Add Nationality";
  add_nationality: any = {
    title_en: "",
    title_ar: "",
  };
  nationalityId: any;
  isEditState = false;

  current_nationality: any;
  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private userService: UserServiceService,
    private fb: FormBuilder,
    private errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    console.log("Add Nationality");
    this.nationalityId = +this.route.snapshot.params["id"];
    if (this.nationalityId > 0) {
      this.isEditState = true;
      this.title = "Edit Nationality";
      this.getNationality(this.nationalityId);
    }
  }

  getNationality(id?) {
    this.userService.getNationalityById(id).subscribe(
      (res: any) => {
        if (res.data) {
          this.add_nationality.title_ar = res.data.title_ar;
          this.add_nationality.title_en = res.data.title_en;
          this.add_nationality.phone = res.data.phone;
          this.add_nationality.phone_2 = res.data.phone_2;
          this.add_nationality.address = res.data.address;
          this.add_nationality.account_number = res.data.account_number;
        }
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  addNationality() {
    this.slimLoadingBarService.start();
    let serUrl;
    if (this.isEditState) {
      serUrl = this.userService.editNationality(this.nationalityId, this.add_nationality);
    } else {
      serUrl = this.userService.addNationality(this.add_nationality);
    }
    console.log(serUrl);
    serUrl.subscribe(
      (data) => {
        if (this.isEditState) {
          swal("Updated Nationality successfully", "", "success");
        } else {
          swal("Added Nationality successfully", "", "success");
        }
        this.add_nationality = {
          title_en: "",
          title_ar: "",
          phone: "",
          phone_2: "",
          address: "",
          account_number: "",
        };
        this.router.navigateByUrl("/pages/settings/nationality");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/add-nationality/add-nationality.component.ts